import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { CFormSwitch, CFormLabel, CForm, CFormInput, CButton, CNav, CNavItem, CNavLink, CTabContent, CTabPane } from '@coreui/react';
import PECopy from './PECopy';

const typeOptions = [
    { value: 'accordion', label: 'Accordion' },
    { value: 'header', label: 'Header' },
    { value: 'subHeader', label: 'Sub Header' },
    { value: 'option', label: 'Option' },
    { value: 'title', label: 'Title' },

];

const hierarchyTypeOptions = [
    { value: 'single', label: 'Single' },
    { value: 'multi', label: 'Multi' },
    { value: 'input', label: 'Input' }
];

const PEAddEditModel = ({ handleSave, editFormData, isEdit, type, onCloseModule, parentID, childID, showCopy = true, showType = true, showHierarchyType = true, apiType }) => {
    const [formData, setFormData] = useState({
        id: Date.now(),
        name: '',
        type: type || '',
        alert: '',
        isHierarchy: false,
        hierarchyType: '',
        hierarchy: [],
        alert: '',
        education: [],
        inputData: '',
        rowAlign: false,
        isSelected: false,
        inNote: true,
        isNewLine: false
    });

    const [typeSelect, setTypeSelect] = useState(null);
    const [activeTab, setActiveTab] = useState('add');


    useEffect(() => {
        if (editFormData) {
            setFormData(editFormData);
            setTypeSelect(typeOptions.find(option => option.value === editFormData.type) || null);
        } else {
            setTypeSelect(typeOptions.find(option => option.value === type) || null);
        }
    }, [editFormData, type]);

    const handleSelectChange = (selectedOption, field) => {
        setFormData(prev => ({ ...prev, [field]: selectedOption?.value || '' }));
    };

    const handleSwitchChange = () => {
        setFormData(prev => ({ ...prev, rowAlign: !prev.rowAlign }));
    };
    const handleSelectedChange = () => {
        setFormData(prev => ({ ...prev, isSelected: !prev.isSelected }));
    }

    const handleInNoteChange = () => {
        setFormData(prev => ({ ...prev, inNote: !prev.inNote }));
    }
    const handleNewLine = () => {
        setFormData(prev => ({ ...prev, isNewLine: !prev.isNewLine }));
    }
    const handleInputChange = (e) => {
        setFormData(prev => ({ ...prev, name: e.target.value }));
    };



    const handleSaveOrEditData = () => {
        if (isEdit && formData.id) {
            handleSave(formData, formData.id);
        } else {
            handleSave(formData);
        }
        setFormData({
            name: '',
            type: '',
            alert: '',
            isHierarchy: false,
            hierarchyType: '',
            hierarchy: []
        });
        onCloseModule()
    };

    const handleClose = () => {
        setFormData({
            name: '',
            type: '',
            alert: '',
            isHierarchy: false,
            hierarchyType: '',
            hierarchy: []
        })
        onCloseModule()
    };



    return (
        <div className="p-1">
            {showType && <CNav variant="pills" role="tablist" className="justify-content-center pe-side-panel__nav" style={{ marginBottom: '10px' }}>
                <CNavItem>
                    <CNavLink active={activeTab === 'add'} onClick={() => setActiveTab('add')}>Add</CNavLink>
                </CNavItem>
                <CNavItem>
                    <CNavLink className={`${showCopy ? '' : 'disabled'}`} active={activeTab === 'copy'} onClick={() => setActiveTab('copy')}>Copy</CNavLink>
                </CNavItem>
            </CNav>}
            <CTabContent>
                <CTabPane visible={activeTab === 'add'}>
                    <CForm>
                        <div className="mb-3">
                            <CFormLabel>Name</CFormLabel>
                            <CFormInput type="text" value={formData.name} onChange={handleInputChange} />
                        </div>
                        {showType && <div className="mb-3">
                            <CFormLabel>Type</CFormLabel>
                            <Select
                                className="basic-single-select ui-react-select"
                                classNamePrefix="select"
                                value={typeSelect}
                                options={typeOptions}
                                onChange={(selected) => {
                                    setTypeSelect(selected);
                                    handleSelectChange(selected, 'type');
                                }}
                                isClearable
                            />
                        </div>}
                        {showHierarchyType && <div className="mb-3">
                            <CFormLabel>Hierarchy Type</CFormLabel>
                            <Select
                                className="basic-single-select ui-react-select"
                                classNamePrefix="select"
                                value={hierarchyTypeOptions.filter((HType) => HType.value === formData.hierarchyType)}
                                options={hierarchyTypeOptions}
                                onChange={(selected) => handleSelectChange(selected, 'hierarchyType')}
                                isClearable
                            />
                        </div>}
                        {showType && <div className=' mb-3 d-flex justify-content-between'>
                            <div className=" ">
                                <CFormLabel>Row Align</CFormLabel>
                                <CFormSwitch checked={formData.rowAlign} onChange={handleSwitchChange} />
                            </div>
                            <div className=" ">
                                <CFormLabel>New Line </CFormLabel>
                                <CFormSwitch checked={formData.isNewLine} onChange={handleNewLine} />
                            </div>
                            <div className=" ">
                                <CFormLabel>Default Value</CFormLabel>
                                <CFormSwitch checked={formData.isSelected} onChange={handleSelectedChange} />
                            </div>

                        </div>}
                        {showType && <div className=" ">
                            <CFormLabel>Show in note</CFormLabel>
                            <CFormSwitch checked={formData.inNote} onChange={handleInNoteChange} />
                        </div>}
                        <div className="d-flex justify-content-end mt-3">
                            <CButton color="secondary" onClick={handleClose} className="ui-action-btn ui-action-btn--secondary me-2">Close</CButton>
                            <CButton color="primary" onClick={() => { handleSaveOrEditData() }} className="ui-action-btn ui-action-btn--primary">Save</CButton>
                        </div>
                    </CForm>
                </CTabPane>
                <CTabPane visible={activeTab === 'copy'} className='' style={{ height: '400px', maxHeight: '600px', overflow: 'auto' }}>
                    {/* <p>Copy functionality will be implemented here.</p> */}
                    <PECopy parentID={parentID} childID={childID} handleSave={handleSave} apiType={apiType} />
                </CTabPane>
            </CTabContent>
        </div>
    );
};

export default PEAddEditModel;
